import React, { useEffect, useState } from "react";
import { getValueAmountOwed } from "utils/buro";
import { pad } from "utils/getLocalDateTime";
import { Button } from "./wrapper";
import { differenceInDays, format } from "date-fns";
import { months } from "../../../utils/getLocalDateTime";
import FileSaver from "file-saver";
import { calReportAging } from "utils/calReportAging";

const iconv = require("iconv-lite");

export const headerStr = `"รหัสสถาบัน"|"งวดข้อมูล"|"เลขที่สัญญา"|"รหัสของผู้กู้"|"ประเภทรหัสของผู้กู้"|"ชื่อผู้กู้"|"ประเภทสินเชื่อ"|"ยอดคงค้าง"|"อัตราดอกเบี้ยที่ผิดนัดชำระหนี้"|"จำนวนวันที่ค้างชำระ"|"การตัดหนี้สูญ (write-off)"`;

export const getObjectPLO = (itemLoan, buroDate, isClearStr = false) => {
  const diffOverdueDate = differenceInDays(
    new Date(buroDate),
    new Date(itemLoan.overdue_date)
  );

  const endOfDate = new Date(buroDate);
  // endOfDate.setDate(months[endOfDate.getMonth()].days);

  // console.log("months", months);
  // console.log("buroDate", buroDate);
  // console.log("endOfDate", endOfDate);

  let valueLoanObj = {
    รหัสสถาบัน: `"0105563138266"`,
    งวดข้อมูล: `"${format(new Date(endOfDate), "yyyy-MM-dd")}"`,
    เลขที่สัญญา: `"${itemLoan?.loan_kbank_id}"`,
    รหัสของผู้กู้: `"${itemLoan?.citizenid}"`,
    ประเภทรหัสของผู้กู้: `"324001"`,
    ชื่อผู้กู้: `"${itemLoan?.fullname}"`,
    ประเภทสินเชื่อ: `"018022"`,
    ยอดคงค้าง: `"${getValueAmountOwed({
      data: itemLoan,
      currentDate: new Date(buroDate),
    })}"`,
    อัตราดอกเบี้ยที่ผิดนัดชำระหนี้:
      diffOverdueDate > 0 ? `"${itemLoan?.loanInterest?.value}"` : `"0"`,
    จำนวนวันที่ค้างชำระ: diffOverdueDate < 0 ? `"0"` : `"${diffOverdueDate}"`,
    การตัดหนี้สูญ: `"0"`,
  };

  if (isClearStr) {
    Object.keys(valueLoanObj).forEach((key) => {
      valueLoanObj[key] = String(valueLoanObj[key])?.replaceAll(/\"/g, "");
    });
  }

  return valueLoanObj;
};

function ReportBotPLO({ loan = [], buroDate = new Date() }) {
  const [loading, setLoading] = useState(false);
  const [dataCsv, setDataCsv] = useState();
  const [error, setError] = useState();
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    if (dataCsv) {
      const filename = `REPORT-BOT-PLO-${format(
        new Date(buroDate),
        "yyyy-MM"
      )}.csv`;
      const buffer = iconv.encode(dataCsv, "utf-8");
      const buroBlob = new Blob([buffer]);
      FileSaver.saveAs(buroBlob, filename);
    }
  }, [dataCsv]);

  const onClickReportBotPLO = async () => {
    try {
      setLoading(true);

      const { dataPrinciple: newLoans } = calReportAging(
        loan,
        new Date(buroDate)
      );

      let bodyStr = ``;
      let index = 0;
      for (const itemLoan of newLoans) {
        if (index >= newLoans.length) {
          break;
        }
        const valuePlo = getObjectPLO(itemLoan, buroDate);
        bodyStr += `${Object.values(valuePlo).join("|")}\n`;
        index++;
      }
      setDataCsv(`${headerStr}\n${bodyStr}`);
      setCountExport(index);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex">
      <Button
        onClick={onClickReportBotPLO}
        loading={loading}
        disabled={loading || !loan.length}
        color="emerald"
      >
        {countExport > 0 && countExport} Report Bot PLO
      </Button>
    </div>
  );
}

export default ReportBotPLO;
